import Vue from 'vue';

export default Vue.filter('truncate', (text = '', length = 30, clamp = '...') => {
  const truncated = text.replace(/<[^>]+>/g, '');
  if (truncated.length <= length) return truncated;

  let tcText = truncated.slice(0, length - clamp.length);
  let last = tcText.length - 1;

  while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) last -= 1;

  last = last || length - clamp.length;

  tcText = tcText.slice(0, last);

  return tcText + clamp;
});
